<div class="global-header-container" [class.global-header-container--fixed-v2-double]="layoutService.getNavV2Layouts() === 'double'">
    @if (lds.get('global-notifications')) {
        <app-bx-global-notifications></app-bx-global-notifications>
    }
</div>
